<template>
    <div class="plaid-container">
        <div v-if="confirm && confirming">
            <table align="center" width="225">
                <tr>
                    <td style="white-space: nowrap;"><b>SSN Last 4</b></td>
                    <td style="padding-left: 10px;">
                        <div>
                            <div class="helper small simple">
                                <span>••• – •• –</span>
                                <input v-model="soc" style="text-indent: 57px;" type="text" placeholder="8888" />
                            </div>
                        </div>
                    </td>
                </tr>
            </table>
            <div>
                <button class="button small" @click="openPlaid"  v-bind:class="[ loading ? 'isLoading' : '',error ? 'red' : '']">
                    <div class="loader small white" style="margin-top: -29px;"></div>
                    <div class="msg" v-if="!error && !success" v-html="button"></div>
                    <div class="msg" v-if="error" v-html="error"></div>
                    <div class="msg" v-if="success" v-html="success"></div>
                </button>
            </div>
        </div>
        <div v-if="!confirming">
            <button class="button" @click="openPlaid"  v-bind:class="[ loading ? 'isLoading' : '',error ? 'red' : '']">
                <div class="loader small white" style="margin-top: -29px;"></div>
                <div class="msg" v-if="!error && !success" v-html="button"></div>
                <div class="msg" v-if="error" v-html="error"></div>
                <div class="msg" v-if="success" v-html="success"></div>
            </button>
        </div>
        <div style="margin-top:10px;">
            <a @click.prevent="addManually()" href="" class="basic lighten">Add Manually</a>
            <div id="manual-bank-account" v-bind:class="{active:addingManually}" style="text-align: left;">
                <div class="account-wrap">
                    <forms action="/billing/add" method="POST">
                        <h1 class="txt lime txt-center" style="margin-top:5px; margin-bottom: 25px;">Add Bank Account</h1>
                        <label>Account Holder Name</label>
                        <input class="small" type="text" name="account_holder_name" />
                        <label>Account Type</label>
                        <select class="small" name="account_holder_type">
                            <option value="">Select...</option>
                            <option value="individual">Individual</option>
                            <option value="company">Company</option>
                        </select>
                        <label>Routing Number</label>
                        <input class="small" type="text" name="routing_number" />
                        <label>Account Number</label>
                        <input class="small" type="text" name="account_number" />

                        <div style="padding:10px;"></div>
                        <confirm-button classes="button block" value="Link Bank Account" message="Saving"></confirm-button>
                        <div class="txt-center" style="margin-top:15px; margin-bottom: -15px;">
                            <a @click.prevent="addingManually = false" href=""  class="basic lighten close">Cancel</a>
                        </div>
                    </forms>
                </div>
            </div>
        </div>
        <div v-bind:style="align == 'center' ? ' margin: 0px auto; margin-top: 40px;' : 'margin-top: 30px;'" style="max-width: 450px;  font-size:13px; line-height: 20px;">
            <span class="lighten">By registering your account, you agree to our</span>
             <a target="_blank" href="https://stripe.com/legal">Services Agreement</a>
            <span class="lighten">and the</span>
            <a target="_blank" href="https://stripe.com/connect-account/legal">Stripe Connected Account Agreement</a>.
        </div>
    </div>
</template>

<script>
    module.exports = {
        created:function() {
            this.confirmed = this.confirm ? false : true;
            this.button = this.buttonMessage;
        },
        data:function() {
            return {
                linkHandler:false,
                client:false,
                loading:false,
                addingManually:false,
                confirmed:true,
                confirming:false,
                error:false,
                success:false,
                soc:'',
                button:'',
                loaded:false
            }
        },
        props: {
            confirm:{type:Boolean,default:false},
            align:{type:String,default:'center'},
            buttonMessage:{type:String,default:'<span class="material-icons">link</span> Link Bank Account'}
        },
        methods: {
            addManually:function() {
                this.addingManually = true
            },
            openPlaid:function() {
                if(this.confirm && !this.confirming) {
                    this.confirming = true;
                    this.button = 'Confirm & Continue';
                } else {
                    if(this.confirm && this.soc.length < 4) {
                        this.error = 'Confirm SSN to continue';
                        var e = this;
                        setTimeout(function() {
                            e.error = false;
                        },3000);
                    } else {
                        this.confirming = false;
                        this.loading = true;
                        if(this.loaded) {
                            this.linkHandler.open();
                        } else {
                            setTimeout(function() {
                                this.openPlaid();
                            }.bind(this),1000);
                        }
                    }
                }
            },
            confirmSoc:function() {

            }
        },
        mounted:function() {
            var e = this;
            $.get('/plaid/token',function(response) {
                var data = $.parseJSON(response);
                if(data.link_token != undefined) {
                    this.linkHandler = Plaid.create({
                        env: $("meta[name='plaid-env']").attr('content'),
                        token:data.link_token,
                        product: ['auth'],
                        onLoad: function () {
                            e.loaded = true;
                        },
                        onSuccess: function (public_token, metadata) {
                            var accountID = metadata.account_id;
                            if (accountID == null) {
                                accountID = metadata.accounts[0].id;
                            }
                            $.post('/billing', {
                                plaid_token: public_token,
                                account_id: accountID,
                                soc:e.soc
                            }, function (data) {
                                console.log(data);
                                if (data.status == 200) {
                                    e.loading = false;
                                    e.success = 'Account Linked! 👍🏻';
                                    setTimeout(function() {
                                        if (e.$modalIsOpen()) {
                                            e.$closeModal();
                                        } else {
                                            document.location.href = document.location.href;
                                        }
                                    },1500);
                                } else {
                                    e.loading = false;
                                    e.error = data.msg;
                                    setTimeout(function() {
                                        e.error = false;
                                    },3000);
                                }
                            });
                        },
                        onExit: function (err, metadata) {
                            e.loading = false;
                        },
                    });
                }
            }.bind(this));
        }
    }
</script>
